var _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8, _stop9, _stop10, _stop11, _stop12, _stop13, _stop14, _stop15, _stop16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";

function SvgBites(props) {
  var _id8 = useUniqueInlineId();

  var _id7 = useUniqueInlineId();

  var _id6 = useUniqueInlineId();

  var _id5 = useUniqueInlineId();

  var _id4 = useUniqueInlineId();

  var _id3 = useUniqueInlineId();

  var _id2 = useUniqueInlineId();

  var _id = useUniqueInlineId();

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 53,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.107%",
    y1: "7.565%",
    x2: "39.227%",
    y2: "87.141%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9900",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE6700",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "67.515%",
    y1: "7.565%",
    x2: "29.281%",
    y2: "87.141%",
    id: _id2
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9900",
    offset: "0%"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE6700",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.107%",
    y1: "7.565%",
    x2: "39.227%",
    y2: "87.141%",
    id: _id3
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1",
    offset: "0%"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C27",
    offset: "99.918%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "67.515%",
    y1: "7.565%",
    x2: "29.281%",
    y2: "87.141%",
    id: _id4
  }, _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1",
    offset: "0%"
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C27",
    offset: "99.918%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.107%",
    y1: "7.565%",
    x2: "39.227%",
    y2: "87.141%",
    id: _id5
  }, _stop9 || (_stop9 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC54BE",
    offset: "0%"
  })), _stop10 || (_stop10 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5802D5",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "67.515%",
    y1: "7.565%",
    x2: "29.281%",
    y2: "87.141%",
    id: _id6
  }, _stop11 || (_stop11 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC54BE",
    offset: "0%"
  })), _stop12 || (_stop12 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5802D5",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: ".377%",
    x2: "50%",
    y2: "100%",
    id: _id7
  }, _stop13 || (_stop13 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17C868",
    offset: ".019%"
  })), _stop14 || (_stop14 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62BD00",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: ".377%",
    x2: "50%",
    y2: "100%",
    id: _id8
  }, _stop15 || (_stop15 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17C868",
    offset: ".019%"
  })), _stop16 || (_stop16 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62BD00",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.798 24.7H2.69C1.207 24.7 0 23.439 0 21.89V2.81C0 1.262 1.207 0 2.69 0h10.108c1.483 0 2.69 1.261 2.69 2.81v19.08c0 1.549-1.207 2.81-2.69 2.81zm-.212-22.674H2.902c-.612 0-1.109.496-1.109 1.108v18.584c0 .612.497 1.108 1.109 1.108h9.684c.612 0 1.108-.496 1.108-1.108V3.134c0-.612-.496-1.108-1.108-1.108zM7.744 19.805c-.495 0-.897.42-.897.936 0 .517.402.937.897.937s.897-.42.897-.937c0-.516-.402-.936-.897-.936zM5.95 3.748h3.586c.496 0 .897.42.897.937 0 .517-.4.937-.897.937H5.951c-.496 0-.897-.42-.897-.937 0-.518.4-.937.897-.937z",
    fill: "url(#".concat(_id, ")"),
    transform: "translate(5 1.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.083 8.307c-.71.428-1.146 1.228-1.146 2.092v3.903c0 .865.436 1.666 1.149 2.093.338.203.72.31 1.107.31.427 0 .846-.13 1.21-.374l3.063-1.952c.654-.444 1.046-1.21 1.046-2.028 0-.82-.392-1.585-1.045-2.028l-3.061-1.95a2.133 2.133 0 00-2.323-.066zM6.38 10l3.066 1.953a.48.48 0 01.195.398.48.48 0 01-.196.398L6.383 14.7a.33.33 0 01-.361.01.471.471 0 01-.214-.407V10.4c0-.176.085-.332.214-.41a.324.324 0 01.358.01z",
    fill: "url(#".concat(_id2, ")"),
    transform: "translate(5 1.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.798 24.7H2.69C1.207 24.7 0 23.439 0 21.89V2.81C0 1.262 1.207 0 2.69 0h10.108c1.483 0 2.69 1.261 2.69 2.81v19.08c0 1.549-1.207 2.81-2.69 2.81zm-.212-22.674H2.902c-.612 0-1.109.496-1.109 1.108v18.584c0 .612.497 1.108 1.109 1.108h9.684c.612 0 1.108-.496 1.108-1.108V3.134c0-.612-.496-1.108-1.108-1.108zM7.744 19.805c-.495 0-.897.42-.897.936 0 .517.402.937.897.937s.897-.42.897-.937c0-.516-.402-.936-.897-.936zM5.95 3.748h3.586c.496 0 .897.42.897.937 0 .517-.4.937-.897.937H5.951c-.496 0-.897-.42-.897-.937 0-.518.4-.937.897-.937z",
    fill: "url(#".concat(_id3, ")"),
    transform: "rotate(-11 144.004 12.368)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.083 8.307c-.71.428-1.146 1.228-1.146 2.092v3.903c0 .865.436 1.666 1.149 2.093.338.203.72.31 1.107.31.427 0 .846-.13 1.21-.374l3.063-1.952c.654-.444 1.046-1.21 1.046-2.028 0-.82-.392-1.585-1.045-2.028l-3.061-1.95a2.133 2.133 0 00-2.323-.066zM6.38 10l3.066 1.953a.48.48 0 01.195.398.48.48 0 01-.196.398L6.383 14.7a.33.33 0 01-.361.01.471.471 0 01-.214-.407V10.4c0-.176.085-.332.214-.41a.324.324 0 01.358.01z",
    fill: "url(#".concat(_id4, ")"),
    transform: "rotate(-11 144.004 12.368)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.798 24.7H2.69C1.207 24.7 0 23.439 0 21.89V2.81C0 1.262 1.207 0 2.69 0h10.108c1.483 0 2.69 1.261 2.69 2.81v19.08c0 1.549-1.207 2.81-2.69 2.81zm-.212-22.674H2.902c-.612 0-1.109.496-1.109 1.108v18.584c0 .612.497 1.108 1.109 1.108h9.684c.612 0 1.108-.496 1.108-1.108V3.134c0-.612-.496-1.108-1.108-1.108zM7.744 19.805c-.495 0-.897.42-.897.936 0 .517.402.937.897.937s.897-.42.897-.937c0-.516-.402-.936-.897-.936zM5.95 3.748h3.586c.496 0 .897.42.897.937 0 .517-.4.937-.897.937H5.951c-.496 0-.897-.42-.897-.937 0-.518.4-.937.897-.937z",
    fill: "url(#".concat(_id5, ")"),
    transform: "rotate(7 -121.037 174.08)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.083 8.307c-.71.428-1.146 1.228-1.146 2.092v3.903c0 .865.436 1.666 1.149 2.093.338.203.72.31 1.107.31.427 0 .846-.13 1.21-.374l3.063-1.952c.654-.444 1.046-1.21 1.046-2.028 0-.82-.392-1.585-1.045-2.028l-3.061-1.95a2.133 2.133 0 00-2.323-.066zM6.38 10l3.066 1.953a.48.48 0 01.195.398.48.48 0 01-.196.398L6.383 14.7a.33.33 0 01-.361.01.471.471 0 01-.214-.407V10.4c0-.176.085-.332.214-.41a.324.324 0 01.358.01z",
    fill: "url(#".concat(_id6, ")"),
    transform: "rotate(7 -121.037 174.08)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.798 24.7H2.69C1.207 24.7 0 23.439 0 21.89V2.81C0 1.262 1.207 0 2.69 0h10.108c1.483 0 2.69 1.261 2.69 2.81v19.08c0 1.549-1.207 2.81-2.69 2.81zm-.212-22.674H2.902c-.612 0-1.109.496-1.109 1.108v18.584c0 .612.497 1.108 1.109 1.108h9.684c.612 0 1.108-.496 1.108-1.108V3.134c0-.612-.496-1.108-1.108-1.108zM7.744 19.805c-.495 0-.897.42-.897.936 0 .517.402.937.897.937s.897-.42.897-.937c0-.516-.402-.936-.897-.936zM5.95 3.748h3.586c.496 0 .897.42.897.937 0 .517-.4.937-.897.937H5.951c-.496 0-.897-.42-.897-.937 0-.518.4-.937.897-.937z",
    fill: "url(#".concat(_id7, ")"),
    transform: "rotate(-11 30.744 -155.763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.083 8.307c-.71.428-1.146 1.228-1.146 2.092v3.903c0 .865.436 1.666 1.149 2.093.338.203.72.31 1.107.31.427 0 .846-.13 1.21-.374l3.063-1.952c.654-.444 1.046-1.21 1.046-2.028 0-.82-.392-1.585-1.045-2.028l-3.061-1.95a2.133 2.133 0 00-2.323-.066zM6.38 10l3.066 1.953a.48.48 0 01.195.398.48.48 0 01-.196.398L6.383 14.7a.33.33 0 01-.361.01.471.471 0 01-.214-.407V10.4c0-.176.085-.332.214-.41a.324.324 0 01.358.01z",
    fill: "url(#".concat(_id8, ")"),
    transform: "rotate(-11 30.744 -155.763)"
  }))));
}

export default SvgBites;